<template>
    <div id="main">
        <!-- CAIXA DE ALERTAS -->
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <div class="page page-container">
            <div class="novo-produto">
                <!-- TÍTULO -->
                <h1 class="title">
                    {{ $t('produto') }}:
                    {{ !produto.idproduto ? $t('adicionar-produto') : produto.descricao }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('vendas') }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ $t('cadastros') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push({ name: 'venda-produtos' })">{{
                                $t('produtos')
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !produto.idproduto ? $t('adicionar-produto') : produto.idprodutoerp
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- CONJTO DE ABAS - DESKTOP -->
                <ul class="nav nav-tabs">
                    <li
                        :class="{ active: abaAtual == i }"
                        @click="changeTab(i)"
                        :key="i"
                        v-for="(aba, i) in abas"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'venda-produtos' })"
                    >
                        {{ $t('voltar') }}
                    </button>
                </div>

                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaAtual]) }}
                        </span>
                        <i class="mdi mdi-chevron-down"></i>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaAtual == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <!-- LOADER -->
                <div class="form-loader" v-show="loadingTab && !$store.getters.isLoading">
                    <div>
                        <svg class="loading">
                            <use
                                :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"
                            ></use>
                        </svg>
                    </div>
                    <div>
                        <span class="loading-tab-text">{{ $t('carregando') }}...</span>
                    </div>
                </div>

                <!-- INFORMAÇÕES GERAIS -->
                <div class="form-geral" v-if="!loadingTab && abaAtual == 0">
                    <!-- CÓDIGO ERP -->
                    <div class="codigo">
                        <v-input
                            ref="codigoERPInput"
                            v-model="produto.idprodutoerp"
                            :maxlength="50"
                            :title="'codigo-do-produto'"
                            disabled
                        />
                    </div>

                    <!-- DESCRIÇÃO -->
                    <div class="descricao">
                        <v-input
                            ref="descricaoInput"
                            v-model="produto.descricao"
                            :maxlength="100"
                            :title="'descricao-produto'"
                            disabled
                        />
                    </div>

                    <!-- GRUPO -->
                    <div class="grupo">
                        <vs-select
                            ref="grupoInput"
                            :value="produto.grupoproduto"
                            :title="'produto-grupo-produto'"
                            label="descricao"
                            disabled
                        />
                    </div>

                    <!-- SUBGRUPO -->
                    <div class="subgrupo">
                        <vs-select
                            ref="subgrupoInput"
                            :value="produto.subgrupoproduto"
                            :title="'produto-subgrupo-produto'"
                            label="descricao"
                            disabled
                        />
                    </div>

                    <!-- LINHA -->
                    <div class="linha">
                        <vs-select
                            ref="linhaInput"
                            :value="produto.linhaproduto"
                            :title="'produto-linhaproduto'"
                            label="descricao"
                            disabled
                        />
                    </div>

                    <!-- CÓDIGO BARRAS -->
                    <div class="codbarras">
                        <v-input
                            ref="codbarrasInput"
                            v-model="produto.codbarras"
                            :maxlength="70"
                            :title="'codigo-barra'"
                            disabled
                        />
                    </div>

                    <!-- NCM -->
                    <div class="ncm">
                        <v-input
                            ref="ncmInput"
                            v-model="produto.ncm"
                            :maxlength="10"
                            :title="'ncm-produto'"
                            disabled
                        />
                    </div>

                    <!-- MARCA -->
                    <div class="marca">
                        <v-input
                            ref="marcaInput"
                            v-model="produto.marca"
                            :maxlength="50"
                            :title="'produto-marca'"
                            disabled
                        />
                    </div>

                    <!-- PESO -->
                    <div class="peso">
                        <v-input
                            ref="pesoInput"
                            v-model="produto.peso"
                            :maxlength="10"
                            :title="'peso-do-produto'"
                            disabled
                        />
                    </div>

                    <!-- UNIDADE MEDIDA -->
                    <div class="unmedida">
                        <vs-select
                            v-if="produto.unidademedida"
                            ref="uncaixaInput"
                            :value="produto.unidademedida"
                            label="descricao"
                            :title="'unidademedida-produto'"
                            disabled
                        />
                        <v-input
                            v-else
                            ref="unmedidaInput"
                            v-model="produto.undmedida"
                            :maxlength="10"
                            :title="'unidademedida-produto'"
                            disabled
                        />
                    </div>

                    <!-- EMBALAGEM -->
                    <div class="embalagem">
                        <v-input
                            ref="embalagemInput"
                            v-model="produto.embalagem"
                            :maxlength="100"
                            :title="'embalagem-produto'"
                            disabled
                        />
                    </div>

                    <!-- UNIDADE CAIXA -->
                    <div class="uncaixa">
                        <v-input
                            ref="uncaixaInput"
                            v-model="produto.undcaixa"
                            :maxlength="10"
                            :title="'unidade-caixa-produto'"
                            disabled
                        />
                    </div>
                </div>

                <!-- ABA TABELA DE PREÇO -->
                <div
                    class="form-tab-preco registry-wrapper"
                    v-else-if="!loadingTab && abaAtual == 1"
                >
                    <!-- TABELA TABELA DE PREÇO -->
                    <label class="tab-subtitle" v-text="$t('tabela-precos')" />
                    <empty-table-message
                        v-if="tabelaPreco.data && !tabelaPreco.data.length"
                        msg="msg-nodata-tabpreco"
                    />
                    <b-table
                        v-else
                        :data="tabelaPreco.data"
                        class="data-table"
                        detailed
                        :mobile-cards="false"
                    >
                        <b-table-column
                            v-for="(u, i) in tabelaPreco.fields"
                            :key="i"
                            :field="u.key"
                            :label="$t(u.label)"
                            :width="u.width"
                            class="td-cell td-center"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'descricao' || u.key == 'datavalidade'">
                                {{ props.row[u.key] }}
                            </div>
                            <div v-else-if="u.key == 'descmaximo1'">
                                {{ props.row.tabprecoprodutos[0][u.key] + ' %' }}
                            </div>
                            <div
                                v-else-if="
                                    [
                                        'valorminimo',
                                        'valor1',
                                        'valormaximo',
                                        'custoproduto',
                                    ].includes(u.key)
                                "
                            >
                                {{
                                    props.row.tabprecoprodutos[0][u.key]
                                        ? produto.prefix +
                                          ' ' +
                                          Number(props.row.tabprecoprodutos[0][u.key])
                                              .toFixed(produto.scale > 8 ? 8 : produto.scale)
                                              .replace('.', $t('scale-separator'))
                                        : '-'
                                }}
                            </div>
                            <div v-else>
                                {{ props.row.tabprecoprodutos[0][u.key] }}
                            </div>
                        </b-table-column>
                        <template slot="detail" slot-scope="props">
                            <div class="columns">
                                <div class="column">
                                    <table>
                                        <tbody>
                                            <tr
                                                class="tabpreco-detail-field"
                                                v-for="(u, i) in tabelaPreco.detailFieldsCol1"
                                                :key="i"
                                            >
                                                <td><label v-text="$t(u.label) + ':'" /></td>
                                                <td>
                                                    <span
                                                        v-text="
                                                            converteBoolean(
                                                                props.row.tabprecoprodutos[0],
                                                                u
                                                            )
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="column">
                                    <table>
                                        <tbody>
                                            <tr
                                                class="tabpreco-detail-field"
                                                v-for="(u, i) in tabelaPreco.detailFieldsCol2"
                                                :key="i"
                                            >
                                                <td><label v-text="$t(u.label) + ':'" /></td>
                                                <td>
                                                    <span
                                                        v-text="
                                                            converteBoolean(
                                                                props.row.tabprecoprodutos[0],
                                                                u
                                                            )
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>

                <!-- ABA ESTOQUE -->
                <div class="form-estoque" v-else-if="!loadingTab && abaAtual == 2">
                    <Estoque :idproduto="produto.idproduto" />
                </div>

                <!-- ABA LOTE -->
                <div class="form-lote registry-wrapper" v-else-if="!loadingTab && abaAtual == 12">
                    <!-- TABELA LOTE -->
                    <label class="tab-subtitle" v-text="$t('lote')" />
                    <empty-table-message
                        v-if="lote.data && !lote.data.length"
                        msg="msg-nodata-lote"
                    />
                    <b-table v-else :data="lote.data" class="data-table">
                        <b-table-column
                            v-for="(u, i) in lote.fields"
                            :key="i"
                            :field="u.key"
                            :label="$t(u.label)"
                            :width="u.width"
                            class="td-cell"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div>
                                {{ props.row[u.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- ABA UNIDADE DE MEDIDA -->
                <div
                    class="form-un-medida registry-wrapper"
                    v-else-if="!loadingTab && abaAtual == 3"
                >
                    <div v-if="permissao.create" class="um-add">
                        <div class="select-add">
                            <label v-text="$t('add-unidade-medida')" />
                            <v-select
                                ref="unMedidaSelect"
                                :options="unidademedida.disponiveis"
                                v-model="unidademedida.selected"
                                :disabled="unidademedida.disableInputs"
                                label="descricao"
                                class="no-clear"
                            >
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                        <div class="perc-input">
                            <label v-text="$t('perc-reajuste')" />
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                :disabled="
                                    unidademedida.selected == null ||
                                    unidademedida.disponiveis.length == 0 ||
                                    unidademedida.disableInputs
                                "
                                v-model="unidademedida.selected.percentualreajuste"
                            />
                        </div>
                        <div class="fator-input">
                            <label v-text="$t('fator-conversao')" />
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                :disabled="
                                    unidademedida.selected == null ||
                                    unidademedida.disponiveis.length == 0 ||
                                    unidademedida.disableInputs
                                "
                                v-model="unidademedida.selected.fatorconversaoestoque"
                            />
                        </div>
                        <div class="add-button">
                            <button
                                class="button btn-add-small"
                                @click="addUnMedida"
                                :disabled="
                                    unidademedida.selected == null ||
                                    unidademedida.disponiveis.length == 0 ||
                                    unidademedida.disableInputs
                                "
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- TABELA -->
                    <empty-table-message
                        v-if="unidademedida.data && !unidademedida.data.length"
                        msg="msg-nodata-unidade-medida"
                    />
                    <b-table v-else :data="unidademedida.data" class="data-table">
                        <b-table-column
                            v-for="(u, i) in unidademedida.fields"
                            :key="i"
                            :field="u.key"
                            :label="u.key != 'actions' ? $t(u.label) : ''"
                            :width="u.width"
                            :class="u.key != 'actions' ? 'td-cell' : 'excluir-field'"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'actions'">
                                <b-button
                                    type="is-danger"
                                    v-if="permissao.delete"
                                    @click="confirmExclusion(props.row, excluirUnMedida)"
                                    icon-right="delete"
                                    position="is-left"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </div>
                            <div v-else-if="u.key == 'descricao'">
                                <a @click="unidademedida.selected = { ...props.row }">
                                    {{
                                        `${props.row[u.key]}${
                                            u.key == 'percentualreajuste' ? '%' : ''
                                        }`
                                    }}
                                </a>
                            </div>
                            <div v-else>
                                {{
                                    `${props.row[u.key]}${u.key == 'percentualreajuste' ? '%' : ''}`
                                }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- ABA SIMILARES E AGREGADOS -->
                <div class="form-sim-agr" v-else-if="!loadingTab && abaAtual == 4">
                    <div class="similar">
                        <label v-text="$t('desc-select-similares')" />
                        <v-select
                            ref="similarSelect"
                            :options="similaresAgregados.similaresDisp"
                            :value="similaresAgregados.similares"
                            :multiple="true"
                            label="descricao"
                            @input="updateSimilares"
                            @search="loadSimilaresDisp"
                            :disabled="
                                similaresAgregados.disableSimilar ||
                                !((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                            class="full-height"
                        >
                            <template slot="no-options">
                                {{ $t('desc-simagr-select-noresult') }}
                            </template>
                            <template slot="option" slot-scope="option">
                                {{ option.descricao }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                {{ option.descricao }}
                            </template>
                        </v-select>
                    </div>

                    <div class="agregado">
                        <label v-text="$t('desc-select-agregados')" />
                        <v-select
                            ref="agregadoSelect"
                            :options="similaresAgregados.agregadosDisp"
                            :value="similaresAgregados.agregados"
                            label="descricao"
                            :multiple="true"
                            @input="updateAgregados"
                            @search="loadAgregadosDisp"
                            :disabled="
                                similaresAgregados.disableAgregado ||
                                !((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                            class="full-height"
                        >
                            <template slot="no-options">
                                {{ $t('desc-simagr-select-noresult') }}
                            </template>
                            <template slot="option" slot-scope="option">
                                {{ option.descricao }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                {{ option.descricao }}
                            </template>
                        </v-select>
                    </div>
                </div>

                <!-- ABA OBSERVAÇÕES -->
                <div class="form-observacoes" v-else-if="!loadingTab && abaAtual == 5">
                    <!-- REFERÊNCIA -->
                    <div class="campo-observacao">
                        <v-input
                            ref="referencia"
                            v-model="observacao.referencia"
                            :maxlength="100"
                            :title="'referencia-produto'"
                            disabled
                        />
                    </div>
                    <!-- COMPLEMENTO -->
                    <div class="campo-observacao">
                        <v-input
                            ref="complemento"
                            v-model="observacao.complemento"
                            :maxlength="255"
                            :title="'complemento-produto'"
                            disabled
                        />
                    </div>
                    <!-- OBSERVACAOGERAL -->
                    <div class="campo-observacao">
                        <v-input
                            ref="observacaogeral"
                            v-model="observacao.observacaogeral"
                            :maxlength="255"
                            :title="'observacaogeral-produto'"
                            disabled
                        />
                    </div>
                </div>

                <!-- ABA INF. TRIBUTÁRIAS -->
                <div class="columns is-1 is-variable" v-else-if="!loadingTab && abaAtual == 6">
                    <!-- CST -->
                    <div class="column">
                        <v-input
                            ref="cst"
                            v-model="infTrib.cst"
                            :maxlength="10"
                            :title="'cst-produto'"
                            disabled
                        />
                    </div>
                    <!-- CEST -->
                    <div class="column">
                        <v-input
                            ref="cest"
                            v-model="infTrib.cest"
                            :maxlength="10"
                            :title="'cest-produto'"
                            disabled
                        />
                    </div>
                </div>

                <!-- ABA FORNECEDORES -->
                <div
                    class="form-fornecedores registry-wrapper"
                    v-else-if="!loadingTab && abaAtual == 7"
                >
                    <!-- TABELA -->
                    <empty-table-message
                        v-if="fornecedores.data && !fornecedores.data.length"
                        msg="msg-nodata-produto-fornecedores"
                    />
                    <b-table v-else :data="fornecedores.data" class="data-table">
                        <b-table-column
                            v-for="(u, i) in fornecedores.fields"
                            :key="i"
                            :field="u.key"
                            :label="$t(u.label)"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'telefone'">
                                {{ maskPhone(props.row[u.key]) }}
                            </div>
                            <div v-else>
                                {{ props.row[u.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- ABA CONFIGURAÇÕES -->
                <div class="form-config registry-wrapper" v-else-if="!loadingTab && abaAtual == 8">
                    <!-- CONFIGS DIVERSAS -->
                    <template v-if="permissao.update">
                        <label class="tab-subtitle" v-text="$t('conf-diversos')" />
                        <div class="conf-diversos">
                            <div class="oculta-input">
                                <label v-text="$t('oculta-prod-catalogo')" />
                                <v-select
                                    :options="config.ocultacatoptions"
                                    v-model="config.oculta"
                                    :disabled="config.disableInputsConfig || hasError"
                                    class="no-clear"
                                >
                                    <template slot="option" slot-scope="option">
                                        {{ $t(option.label) }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ $t(option.label) }}
                                    </template>
                                    <template slot="no-options">{{
                                        $t('sem-resultados')
                                    }}</template>
                                </v-select>
                            </div>
                            <div class="porctroca-input">
                                <label v-text="$t('porc-troca')" />
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="config.porctroca"
                                    :disabled="config.disableInputsConfig || hasError"
                                />
                            </div>
                            <div class="add-button">
                                <button
                                    class="button btn-add-small"
                                    @click="salvarConfig"
                                    :disabled="config.disableInputsConfig || hasError"
                                >
                                    {{ $t('salvar-conf-diversos') }}
                                </button>
                            </div>
                        </div>
                        <hr />
                    </template>

                    <!-- DESCONTO POR QUANTIDADE -->
                    <label class="tab-subtitle" v-text="$t('desconto-qtde')" />
                    <template v-if="permissao.create || permissao.update">
                        <div class="desc-qtd-edit">
                            <div class="ini-input">
                                <label v-text="$t('qtd-ini')" />
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="config.descqtd_edit.qtdeinicio"
                                    :disabled="config.disableInputsDesconto || hasError"
                                />
                            </div>
                            <div class="fim-input">
                                <label v-text="$t('qtd-fim')" />
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="config.descqtd_edit.qtdefim"
                                    :disabled="config.disableInputsDesconto || hasError"
                                />
                            </div>
                            <div class="reajuste-input">
                                <label v-text="`${$t('reajuste')} (%)`" />
                                <input
                                    type="number"
                                    step="0.01"
                                    v-model="config.descqtd_edit.diferenca"
                                    :disabled="config.disableInputsDesconto || hasError"
                                />
                            </div>
                            <div class="empresa-desc-input">
                                <label v-text="$t('empresa')" />
                                <v-select
                                    :options="config.empresas"
                                    label="nome"
                                    v-model="config.descqtd_edit.empresa"
                                    class="no-clear"
                                    :disabled="config.disableInputsConfig || hasError"
                                    :loading="config.empresasLoading"
                                    @search="loadVendedores"
                                >
                                    <template slot="option" slot-scope="option">
                                        {{ option.id == 0 ? $t(option.nome) : option.nome }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.id == 0 ? $t(option.nome) : option.nome }}
                                    </template>
                                    <template slot="no-options">
                                        {{ $t('sem-resultados-filtro') }}
                                    </template>
                                </v-select>
                            </div>
                            <div class="tabpreco-input">
                                <label v-text="$t('tab-preco')" />
                                <v-select
                                    ref="config-tabPrecoInput"
                                    class="no-clear"
                                    label="descricao"
                                    v-model="config.descqtd_edit.tabpreco"
                                    :options="config.tabelasPreco"
                                    :loading="config.tabelasPrecoLoading"
                                    :disabled="config.disableInputsDesconto || hasError"
                                    @search="loadTabelasPreco"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </v-select>
                            </div>
                            <div class="add-button">
                                <button
                                    class="button btn-add-small"
                                    @click="salvarDesconto"
                                    :disabled="
                                        (!permissao.create && config.descqtd_selected == null) ||
                                        config.disableInputsDesconto ||
                                        hasError
                                    "
                                >
                                    {{
                                        config.descqtd_selected != null
                                            ? $t('salvar')
                                            : $t('adicionar')
                                    }}
                                </button>
                                <button
                                    class="button btn-del-small"
                                    @click="cancelDesconto"
                                    v-show="config.descqtd_selected != null"
                                    :disabled="config.disableInputsDesconto || hasError"
                                >
                                    {{ $t('cancelar') }}
                                </button>
                            </div>
                        </div>
                    </template>

                    <!-- TABELA -->
                    <empty-table-message
                        class="config-empty"
                        v-if="(config.descqtd_data && !config.descqtd_data.length) || hasError"
                        msg="msg-nodata-desconto-quantidade"
                    />
                    <b-table
                        v-else
                        class="data-table"
                        :data="hasError ? [] : config.descqtd_data"
                        :selected="config.descqtd_selected"
                    >
                        <b-table-column
                            v-for="(u, i) in config.descqtd_fields"
                            :key="i"
                            :field="u.key"
                            :label="u.key != 'actions' ? $t(u.label) : ''"
                            :width="u.width"
                            :class="u.key != 'actions' ? 'td-cell' : 'excluir-field'"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'actions'" style="min-width: 100px">

                                <b-button
                                    v-if="permissao.update"
                                    @click="editDesconto(props.row)"
                                    icon-right="pencil"
                                    position="is-left"
                                    :disabled="config.disableInputsDesconto"
                                    v-tippy 
                                    :title="$t('editar')"
                                />
                                <b-button
                                    v-if="permissao.delete"
                                    class="ml-1"
                                    type="is-danger"
                                    @click="confirmExclusion(props.row, excluirDesconto)"
                                    icon-right="delete"
                                    position="is-left"
                                    :disabled="config.disableInputsDesconto"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </div>
                            <div v-if="u.key == 'intervalo'">
                                {{ props.row.qtdeinicio }} - {{ props.row.qtdefim }}
                            </div>
                            <div v-else-if="u.key == 'reajuste'">
                                {{ getDecimal(props.row.diferenca) }}
                                %
                            </div>
                            <div v-else-if="u.key == 'tabpreco'">
                                {{ props.row.tabpreco.descricao }}
                            </div>
                            <div v-else-if="u.key == 'empresa'">
                                {{ props.row.empresa ? props.row.empresa.nome : $t('todas') }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <hr />

                    <!-- MULTIPLICADOR -->
                    <label class="tab-subtitle" v-text="$t('multiplicadores')" />
                    <template v-if="permissao.update">
                        <div class="mult-edit">
                            <div class="venda-input">
                                <label v-text="$t('mult-venda')" />
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="config.mult_edit.venda"
                                    :disabled="
                                        config.disableInputsMultiplicador ||
                                        config.mult_selected == null ||
                                        hasError
                                    "
                                />
                            </div>
                            <div class="troca-input">
                                <label v-text="$t('mult-troca')" />
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="config.mult_edit.troca"
                                    :disabled="
                                        config.disableInputsMultiplicador ||
                                        config.mult_selected == null ||
                                        hasError
                                    "
                                />
                            </div>
                            <div class="empresa-input">
                                <label v-text="$t('empresa')" />
                                <v-select
                                    ref="config-vendedorInput"
                                    class="no-clear"
                                    label="nome"
                                    v-model="config.mult_edit.empresa"
                                    :options="config.empresas"
                                    :loading="config.empresasLoading"
                                    :disabled="
                                        config.disableInputsMultiplicador ||
                                        config.mult_selected == null ||
                                        hasError
                                    "
                                    @search="loadVendedores"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </v-select>
                            </div>
                            <div class="add-button">
                                <button
                                    class="button btn-add-small"
                                    @click="salvarMultiplicador"
                                    :disabled="
                                        config.disableInputsMultiplicador ||
                                        config.mult_selected == null ||
                                        hasError
                                    "
                                >
                                    {{ $t('salvar') }}
                                </button>
                                <button
                                    class="button btn-del-small"
                                    @click="cancelMultiplicador"
                                    :disabled="config.disableInputsMultiplicador || hasError"
                                >
                                    {{ $t('cancelar') }}
                                </button>
                            </div>
                            <h3 v-if="bloqueiaMultiplicadorERP">
                                {{ $t('informacao-multiplicador-integracao') }}
                            </h3>
                        </div>
                    </template>

                    <!-- TABELA -->
                    <empty-table-message
                        class="config-empty"
                        v-if="(config.mult_data && !config.mult_data.length) || hasError"
                        msg="msg-nodata-multiplicadores"
                    />
                    <b-table
                        v-else
                        class="data-table"
                        :data="hasError ? [] : config.mult_data"
                        :selected="config.mult_selected"
                    >
                        <b-table-column
                            v-for="(u, i) in config.mult_fields"
                            :key="i"
                            :field="u.key"
                            :label="u.key != 'actions' ? $t(u.label) : ''"
                            :width="u.width"
                            :class="u.key != 'actions' ? 'td-cell' : 'excluir-field'"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'actions'" style="min-width: 100px">
                                <b-button
                                    v-if="permissao.update"
                                    @click="editMultiplicador(props.row)"
                                    icon-right="pencil"
                                    position="is-left"
                                    :disabled="config.disableInputsMultiplicador || hasError"
                                    v-tippy 
                                    :title="$t('editar')"
                                />
                                <b-button
                                    v-if="permissao.delete"
                                    class="ml-1"
                                    type="is-danger"
                                    @click="
                                        confirmExclusion(
                                            props.row,
                                            excluirMultiplicador,
                                            'msg-del-multiplicador'
                                        )
                                    "
                                    icon-right="delete"
                                    position="is-left"
                                    :disabled="config.disableInputsMultiplicador || hasError"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </div>
                            <div v-else-if="u.key == 'empresa'">
                                {{ props.row.empresa.nome }}
                            </div>
                            <div
                                v-else-if="
                                    u.key == 'multiplicadorweb' || u.key == 'multiplicadortrocaweb'
                                "
                            >
                                {{ getDecimal(props.row[u.key]) }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- ABA CULTURA -->
                <div class="form-cultura" v-else-if="!loadingTab && abaAtual == 9">
                    <div class="cultura">
                        <label v-text="$t('desc-select-cultura')" />
                        <v-select
                            ref="culturaSelect"
                            :options="cultura.culturasDisponiveis"
                            :value="cultura.culturas"
                            :multiple="true"
                            label="descricao"
                            @input="updateCulturas"
                            :disabled="
                                cultura.disableCultura ||
                                !((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                            class="full-height"
                        >
                            <template slot="no-options">
                                {{ $t('desc-cultura-select-noresult') }}
                            </template>
                            <template slot="option" slot-scope="option">
                                {{ option.tipocultura.descricao }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                {{ option.tipocultura.descricao }}
                            </template>
                        </v-select>
                    </div>
                </div>

                <!-- ABA LICENÇA -->
                <div
                    class="form-licenca registry-wrapper"
                    v-else-if="!loadingTab && abaAtual == 10"
                >
                    <div v-if="permissao.create" class="add-licenca">
                        <div class="select-add">
                            <label v-text="$t('licenca-nao-atribuida')" />
                            <v-select
                                ref="licencaSelect"
                                class="no-clear"
                                label="idassprodutolicenca"
                                v-model="licenca.selected"
                                :options="licenca.disponiveis"
                                :disabled="licenca.isSaving"
                                :loading="licenca.isLoading"
                            >
                                <template slot="no-options">
                                    {{
                                        $t('desc-licenca-select-noresult')
                                    }}
                                </template>
                                <template slot="option" slot-scope="option">
                                    {{ option.licenca.idlicencaerp }} -
                                    {{ option.licenca.descricao }} -
                                    {{
                                        option.licenca.bloqueiavenda
                                            ? $t('bloqueia-venda').toUpperCase()
                                            : $t('nao-bloqueia-venda').toUpperCase()
                                    }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ option.licenca.idlicencaerp }} -
                                    {{ option.licenca.descricao }} -
                                    {{
                                        option.licenca.bloqueiavenda
                                            ? $t('bloqueia-venda').toUpperCase()
                                            : $t('nao-bloqueia-venda').toUpperCase()
                                    }}
                                </template>
                            </v-select>
                        </div>
                        <div class="btn-add">
                            <button
                                class="button btn-add-small"
                                :disabled="licenca.selected == null || licenca.isSaving"
                                @click="addLicenca"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- TABELA -->
                    <empty-table-message
                        v-if="licenca.data && !licenca.data.length"
                        msg="msg-nodata-licenca"
                    />
                    <b-table v-else :data="licenca.data" class="data-table">
                        <b-table-column
                            v-for="(u, i) in licenca.fields"
                            :key="i"
                            :field="u.key"
                            :label="u.key != 'actions' ? $t(u.label) : ''"
                            :width="u.width"
                            :class="u.key != 'actions' ? 'td-cell' : 'excluir-field'"
                            :sortable="u.sortable"
                            v-slot="props"
                        >
                            <div v-if="u.key == 'actions'">
                                <b-button
                                    v-if="permissao.delete"
                                    type="is-danger"
                                    @click="confirmExclusion(props.row, excluirLicenca)"
                                    icon-right="delete"
                                    position="is-left"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </div>
                            <div v-else-if="u.key == 'bloqueiavenda'">
                                {{ props.row.licenca[u.key] ? $t('sim') : $t('nao') }}
                            </div>
                            <div v-else>
                                {{ props.row.licenca[u.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- ABA GRADE -->
                <div class="form-grade registry-wrapper" v-else-if="!loadingTab && abaAtual == 11">
                    <div class="columns">
                        <div class="column is-full">
                            <v-input
                                ref="idgradeerp"
                                v-model="grade.idgradeerp"
                                :maxlength="255"
                                title="codigo-grade"
                                disabled
                            />
                        </div>
                    </div>

                    <!-- TABELA GRADE -->
                    <empty-table-message
                        v-if="grade.data && !grade.data.length"
                        msg="grade-vazia"
                    />
                    <b-table v-else :data="grade.data" class="data-table" :bordered="true">
                        <b-table-column
                            key="0"
                            field="descricao"
                            label=""
                            class="td-cell"
                            :sortable="false"
                            v-slot="props"
                        >
                            <div>
                                {{ props.row['descricao'] }}
                            </div>
                        </b-table-column>
                        <b-table-column
                            v-for="(u, i) in grade.fields"
                            :key="i + 1"
                            :field="u.key"
                            :label="u.label"
                            :width="u.width"
                            class="td-cell"
                            :sortable="false"
                            v-slot="props"
                        >
                            <div>
                                {{ props.row[u.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import VenProdutoValidation from '@/services/validations/VenProdutoValidation';
import Message from '@/models/Message';
import Estoque from '@/components/vendas/produto-old/abas/Estoque';
import { Promise } from 'q';
import { setTimeout } from 'timers';

export default {
    components: {
        Estoque,
    },
    data() {
        return {
            abaAtual: 0,
            abas: [
                'geral',
                'aba-tab-preco',
                'aba-estoque',
                'aba-un-medida',
                'aba-similares-agregados',
                'aba-observacoes',
                'aba-inf-trib',
                'aba-fornecedores',
                'aba-config',
                'aba-cultura',
                'aba-licenca',
                'aba-grade',
                'aba-lote',
            ],
            loadingTab: false,
            msgs: [],
            produto: {
                idproduto: null,
                idprodutoerp: null,
                descricao: null,
                grupo: null,
                subgrupo: null,
                linha: null,
                codBarras: null,
                ncm: null,
                marca: null,
                peso: null,
                unmedida: null,
                embalagem: null,
                uncaixa: null,
            },
            tabelaPreco: {
                fields: [
                    { key: 'descricao', label: 'descricao', sortable: true },
                    { key: 'valor1', label: 'valor', sortable: true },
                    {
                        key: 'valorminimo',
                        label: 'tabelapreco-valorminimo',
                        sortable: true,
                    },
                    {
                        key: 'valormaximo',
                        label: 'tabelapreco-valormaximo',
                        sortable: true,
                    },
                    {
                        key: 'descmaximo1',
                        label: 'tabelapreco-descmaximo',
                        sortable: true,
                    },
                    { key: 'custoproduto', label: 'tabelapreco-custo', sortable: true },
                    {
                        key: 'datavalidade',
                        label: 'tabelapreco-datavalidade',
                        sortable: true,
                    },
                ],
                // DETALHES
                detailFieldsCol1: [
                    {
                        key: 'liberaalteracao',
                        label: 'tabelapreco-liberaalteracao',
                        booleano: true,
                    },
                    { key: 'encargo', label: 'tabelapreco-encargo' },
                    {
                        key: 'descflexvlrmenor',
                        label: 'tabelapreco-descflexvlrmenor',
                        booleano: true,
                    },
                    {
                        key: 'acresflexvlrmaior',
                        label: 'tabelapreco-acresflexvlrmaior',
                        booleano: true,
                    },
                    {
                        key: 'ignoraregraprazo',
                        label: 'tabelapreco-ignoraregraprazo',
                        booleano: true,
                    },
                ],
                detailFieldsCol2: [
                    {
                        key: 'permitetroca',
                        label: 'tabelapreco-permitetroca',
                        booleano: true,
                    },
                    {
                        key: 'permitebonificacao',
                        label: 'tabelapreco-permitebonificacao',
                        booleano: true,
                    },
                    {
                        key: 'permitebonifnavenda',
                        label: 'tabelapreco-permitebonifnavenda',
                        booleano: true,
                    },
                    { key: 'qtdeminimavenda', label: 'tabelapreco-qtdeminimavenda' },
                    { key: 'comissao', label: 'tabelapreco-comissao' },
                ],
            },
            estoque: {
                fields: [
                    { key: 'empresa', label: 'empresa', sortable: true },
                    {
                        key: 'datahoraupdatesaldo',
                        label: 'data-ultima-movimentacao',
                        sortable: true,
                    },
                    { key: 'saldo', label: 'saldo', sortable: true },
                ],
                data: [],
            },
            lote: {
                fields: [
                    { key: 'descricao', label: 'descricao', sortable: true },
                    { key: 'datafabricacao', label: 'data-fabricacao', sortable: true },
                    { key: 'datavalidade', label: 'data-validade', sortable: true },
                    { key: 'qtde', label: 'quantidade', sortable: true },
                ],
                data: [],
            },
            unidademedida: {
                /* Colunas da tabela */
                fields: [
                    { key: 'descricao', label: 'descricao', sortable: true },
                    {
                        key: 'percentualreajuste',
                        label: 'perc-reajuste',
                        sortable: false,
                    },
                    {
                        key: 'fatorconversaoestoque',
                        label: 'fator-conversao',
                        sortable: false,
                    },
                    { key: 'actions', label: '', width: 70, sortable: false },
                ],
                data: null /* Dados da tabela */,
                disponiveis: null /* Un. Medidas disponíveis para associação */,
                selected: {} /* Un. Medida selecionada atualmente */,
                percentualreajuste: null /* Valor do campo Perc. de Reajuste */,
                fatorConv: null /* Valor do campo Fator de Conv. */,
                disableInputs: false /* Desabilitar os inputs dos campos? */,
            },
            similaresAgregados: {
                disableSimilar: false /* Desabilitar o select de produtos similares? */,
                similares: [] /* Produtos similares associados */,
                similaresDisp: [] /* Produtos disponíveis a serem associados para similares */,
                disableAgregado: false /* Desbilitar o select de produtos agregados ? */,
                agregados: [] /* Produtos agregados associados */,
                agregadosDisp: [] /* Produtos disponíveis a serem associados para agregados */,
                hasListeners: false,
            },
            observacao: {
                referencia: null,
                complemento: null,
                observacaogeral: null,
            },
            infTrib: {
                cst: null,
                cest: null,
            },
            fornecedores: {
                fields: [
                    { key: 'nome', label: 'nome', sortable: true },
                    { key: 'rsocial', label: 'razao-social', sortable: true },
                    { key: 'bairro', label: 'bairro', sortable: true },
                    { key: 'cidade', label: 'cidade', sortable: true },
                    { key: 'estado', label: 'estado', sortable: true },
                    { key: 'telefone', label: 'telefone', sortable: true },
                ],
                data: null,
            },
            config: {
                // Desconto por Quantidade
                descqtd_data: null,
                descqtd_fields: [
                    { key: 'tabpreco', label: 'tab-preco', sortable: false },
                    { key: 'empresa', label: 'empresa', sortable: false },
                    { key: 'intervalo', label: 'intervalo', sortable: false },
                    { key: 'reajuste', label: 'reajuste', sortable: false },
                    { key: 'actions', label: '', width: 70, sortable: false },
                ],
                descqtd_selected: null,
                descqtd_edit: {
                    idprodutoqtdepreco: null,
                    qtdeinicio: '',
                    qtdefim: '',
                    diferenca: '',
                    tabpreco: null,
                },
                tabelasPreco: [],
                tabelasPrecoLoading: false,
                disableInputsDesconto: false,
                // Multiplicadores
                mult_data: null,
                mult_fields: [
                    { key: 'empresa', label: 'empresa', sortable: false },
                    { key: 'multiplicadorweb', label: 'mult-venda', sortable: false },
                    {
                        key: 'multiplicadortrocaweb',
                        label: 'mult-troca',
                        sortable: false,
                    },
                    { key: 'actions', label: '', width: 70, sortable: false },
                ],
                mult_selected: null,
                mult_edit: {
                    idassprodutoempresa: null,
                    venda: '',
                    troca: '',
                    empresa: null,
                },
                empresas: [],
                empresasLoading: false,
                disableInputsMultiplicador: false,
                // Conf diversas
                oculta: null,
                ocultacatoptions: [
                    { id: 0, label: 'nao' },
                    { id: 1, label: 'sim' },
                ],
                porctroca: null,
                disableInputsConfig: false,
                startValues: {
                    oculta: null,
                    porctroca: null,
                },
            },
            cultura: {
                disableCultura: false /* Desabilitar o select de culturas? */,
                culturas: [] /* Culturas associadas */,
                culturasDisponiveis: [] /* Culturas disponíveis a serem associadas ao produto */,
            },
            licenca: {
                fields: [
                    { key: 'descricao', label: 'descricao', sortable: true },
                    { key: 'bloqueiavenda', label: 'bloqueio-venda', sortable: false },
                    { key: 'actions', label: '', width: 70, sortable: false },
                ],
                disponiveis: [],
                data: null,
                selected: null,
                isSaving: false,
                isLoading: false,
            },
            grade: {
                fields: [],
                data: [],
            },
            service: null,
            empresaService: null,
            deleteThis: {},
            validation: null,
            limit: 20,
            hasError: false,
            permissao: {},
            bloqueiaMultiplicadorERP: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'venda-produtos');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'produto' },
            });

        this.loadingTab = true;
        this.service = new VenProdutoService(this.$http, this.$router);
        this.empresaService = new EmpresaService(this.$http, this.$router);
        this.validation = new VenProdutoValidation(this.msgs);

        this.$set(this.produto, 'idproduto', this.$route.params.id);
        this.loadTab(this.abaAtual);
    },
    methods: {
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        changeTab(i) {
            if (!this.loadingTab) {
                this.abaAtual = i;
                this.loadTab(i);
            }
        },
        loadTab(i) {
            this.loadingTab = true;
            this.hasError = false;

            switch (i) {
                case 0 /* GERAL */:
                    this.loadTabGeral();
                    break;
                case 1 /* TABELA DE PREÇO */:
                    this.loadTabTabelaPreco();
                    break;
                case 2 /* ESTOQUE */:
                    this.loadingTab = false;
                    // this.loadTabEstoque();
                    break;
                case 3 /* UNIDADE DE MEDIDA */:
                    this.loadTabUnMedida();
                    break;
                case 4 /* SIMILARES E AGREGADOS */:
                    this.loadTabSimilaresAgregados();
                    break;
                case 5 /* OBSERVAÇÕES */:
                    this.loadTabObservacoes();
                    break;
                case 6 /* INF. TRIBUTÁRIAS */:
                    this.loadTabInfTrib();
                    break;
                case 7 /* FORNECEDORES */:
                    this.loadTabFornecedores();
                    break;
                case 8 /* CONFIGURAÇÕES */:
                    this.loadTabConfig();
                    break;
                case 9 /* CULTURA */:
                    this.loadTabCultura();
                    break;
                case 10 /* LICENÇA */:
                    this.loadTabLicenca();
                    break;
                case 11 /* GRADE */:
                    this.loadTabGrade();
                    break;
                case 12 /* LOTE */:
                    this.loadTabLote();
                    break;
                default:
                    console.error(`Aba inválida: ${i}`);
                    break;
            }
        },
        loadTabGeral() {
            this.service
                .loadGeral(this.produto.idproduto)
                .then((r) => {
                    this.produto = r.content;
                })
                .catch((e) => {
                    console.error('Erro ao carregar dados gerais.', e);

                    this.msgs.push(new Message('error', 'msg-erro-dados-geral', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabTabelaPreco() {
            this.service
                .loadTabelaPreco(this.produto.idproduto)
                .then((r) => {
                    if (r.content) {
                        this.tabelaPreco.data = r.content;
                        this.tabelaPreco.data.forEach((tp) => {
                            tp.datavalidade = this.parseDateString(tp.datavalidade);
                        });
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar tabela de preço.', e);

                    this.msgs.push(new Message('error', 'msg-erro-tab-preco', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        converteBoolean(row, field) {
            if (field.booleano) {
                if (typeof row[field.key] == 'boolean') {
                    return this.$t(row[field.key] ? 'sim' : 'nao').toUpperCase();
                }
                switch (row[field.key]) {
                    case 1:
                        return this.$t('sim').toUpperCase();
                    case 0:
                        return this.$t('nao').toUpperCase();
                    default:
                        return '';
                }
            } else {
                if (field.key == 'qtdeminimavenda') {
                    return Number(row[field.key]).toFixed(
                        this.produto.scaleqtd > 8 ? 8 : this.produto.scaleqtd
                    );
                }
                return row[field.key];
            }
        },
        loadTabLote() {
            const requests = [];
            requests.push(
                this.service.loadLote(this.produto.idproduto).then((r) => {
                    this.lote.data = r.map((item) => {
                        return {
                            descricao: item.lote.descricao,
                            datafabricacao: this.parseDateString(item.datafabricacao),
                            datavalidade: this.parseDateString(item.datavalidade),
                            qtde: item.qtde,
                        };
                    });
                })
            );

            Promise.all(requests)
                .then(() => {
                    this.loadingTab = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar estoque.', e);

                    this.msgs.push(new Message('error', 'msg-erro-estoque', true));
                    this.loadingTab = false;
                });
        },
        loadTabUnMedida() {
            this.service
                .loadUnMedida(this.produto.idproduto)
                .then((r) => {
                    let content = r.content;

                    if (content) {
                        this.unidademedida.data = content.data;
                        this.unidademedida.disponiveis = content.disponiveis;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar unidade de medida.', e);

                    this.msgs.push(new Message('error', 'msg-erro-un-medida', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabSimilaresAgregados(isReload = false) {
            this.service
                .loadSimilaresAgregados(this.produto.idproduto)
                .then((r) => {
                    if (r.content) {
                        this.similaresAgregados.similares = r.content.similares.data;
                        this.similaresAgregados.similaresDisp = r.content.similares.disponiveis;

                        this.similaresAgregados.agregados = r.content.agregados.data;
                        this.similaresAgregados.agregadosDisp = r.content.agregados.disponiveis;
                    }

                    if (!isReload) {
                        this.addSelectListeners();
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar similares e agregados.', e);

                    this.msgs.push(new Message('error', 'msg-erro-similares-agregados', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabObservacoes() {
            this.service
                .loadObservacoes(this.produto.idproduto)
                .then((r) => {
                    this.observacao = r;
                })
                .catch((e) => {
                    console.error('Erro ao carregar observações.', e);

                    this.msgs.push(new Message('error', 'msg-erro-observacoes', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabInfTrib() {
            this.service
                .loadInfTrib(this.produto.idproduto)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Status ${r.status} ao carregar dados de informações tributárias.`
                        );
                        this.showMessage('error', 'msg-erro-inf-trib');
                    } else {
                        this.infTrib = r.content;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar informações tributárias.', e);
                    this.showMessage('error', 'msg-erro-inf-trib');
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabFornecedores() {
            this.service
                .loadFornecedores(this.produto.idproduto)
                .then((r) => {
                    if (r.status != 200) {
                        console.error('Erro ao carregar fornecedores.', e);

                        this.msgs.push(new Message('error', 'msg-erro-fornecedores', true));
                    } else {
                        this.fornecedores.data = r.content;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar fornecedores.', e);

                    this.msgs.push(new Message('error', 'msg-erro-fornecedores', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabConfig() {
            this.service
                .loadConfig(this.produto.idproduto)
                .then((r) => {
                    if (r.status != 200) {
                        this.showMessage('error', 'msg-erro-config');
                        this.hasError = true;
                    } else {
                        this.config.descqtd_data = r.content.produtoqtdepreco;
                        this.config.mult_data = r.content.multiplicadores;
                        this.config.oculta = this.config.ocultacatoptions[r.content.oculta];
                        this.config.porctroca = r.content.porctroca;

                        this.loadVendedores('');
                        this.loadTabelasPreco('');
                        this.saveStartValuesConfig();
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar configurações.', e);
                    this.showMessage('error', 'msg-erro-config');
                    this.hasError = true;
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabCultura(isReload = false) {
            this.service
                .loadCulturas(this.produto.idproduto)
                .then((r) => {
                    if (r.content) {
                        this.cultura.culturas = r.content.data;
                        this.cultura.culturasDisponiveis = r.content.disponiveis;
                    }

                    if (!isReload) {
                        this.addCulturaSelectListeners();
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar cultura.', e);

                    this.msgs.push(new Message('error', 'msg-erro-cultura', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabLicenca() {
            // this.loadLicencaDisp();

            this.service
                .loadLicenca(this.produto.idproduto)
                .then((r) => {
                    if (r.content) {
                        this.licenca.data = r.content.data;
                        this.licenca.disponiveis = r.content.disponiveis;
                    }
                    this.loadingTab = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar licença.', e);

                    this.msgs.push(new Message('error', 'msg-erro-licenca', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        loadTabGrade() {
            this.service
                .loadGrade(this.produto.idproduto)
                .then((r) => {
                    if (r) {
                        this.grade.idgradeerp = r.idgradeerp;
                        if (r.colunas) {
                            this.grade.fields = r.colunas.map((gradeColuna) => {
                                return {
                                    key: gradeColuna.descricao,
                                    label: gradeColuna.descricao,
                                };
                            });
                        }
                        this.grade.data = r.linhas;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar grade.', e);

                    this.msgs.push(new Message('error', 'msg-erro-grade', true));
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        confirmExclusion(item, delFunc, msg) {
            this.$root.confirm({
                message: this.$t(msg ? msg : 'msg-confirmacao'),
                onConfirm: (_) => {
                    delFunc(item);
                },
            });
        },
        /* MÉTODOS ABA UNIDADE DE MEDIDA */
        excluirUnMedida(item) {
            this.loadingTab = true;

            /* Realizar exclusão do item no backend */
            this.service
                .delUnMedida(item.idassprodutounidademedida)
                .then((r) => {
                    // Recarregar a aba
                    this.loadTab(this.abaAtual);

                    // Reabilitar a entrada
                    this.unidademedida.disableInputs = false;
                })
                .catch((e) => {
                    console.error('Erro ao excluir unidade de medida.', e);

                    this.loadingTab = false;

                    this.msgs.push(new Message('error', 'msg-erro-del-un-medida', true));
                });
        },
        addUnMedida() {
            if (this.validation.validateNovaUnMedida(this.unidademedida)) {
                this.unidademedida.disableInputs = true;

                let um = { ...this.unidademedida.selected };
                um.idproduto = this.produto.idproduto;

                /* Adicionar item no backend */
                this.service
                    .addUnMedida(um)
                    .then((r) => {
                        // Resetar os valores, em caso de sucesso
                        this.unidademedida.selected = {};
                        this.unidademedida.fatorconversaoestoque = null;
                        this.unidademedida.percentualreajuste = null;

                        this.msgs.push(new Message('success', 'msg-success-add-un-medida', true));

                        // Recarregar a aba
                        this.loadTab(this.abaAtual);

                        // Reabilitar a entrada
                        this.unidademedida.disableInputs = false;
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar unidade de medida', e);

                        this.msgs.push(new Message('error', 'msg-erro-add-un-medida', true));

                        // Reabilitar a entrada
                        this.unidademedida.disableInputs = false;
                    });
            }
        },
        /* MÉTODOS ABA SIMILARES E AGREGADOS */
        updateSimilares(newv) {
            let oldv = this.similaresAgregados.similares;

            /* Entradas removidas: filtra os antigos que não estão nos novos */
            let del = oldv.filter((p) => !newv.includes(p));

            /* Entradas adicionadas: filtra os novos que não estão nos antigos */
            let add = newv
                .filter((p) => !oldv.includes(p))
                .map((p) => {
                    p.idprodutoprincipal = this.produto.idproduto;
                    return p;
                });

            if (del.length > 0) {
                this.similaresAgregados.disableSimilar = true;

                /* Remover no back */
                this.service
                    .delSimilar(del[0].id)
                    .then((r) => {
                        // this.similaresAgregados.similares = newv;
                        this.loadTabSimilaresAgregados(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao remover produto similar', e);

                        this.msgs.push(new Message('error', 'msg-erro-del-similar', true));
                    })
                    .finally(() => {
                        this.similaresAgregados.disableSimilar = false;

                        this.$nextTick(() => {
                            this.$refs.similarSelect.open = true;
                            this.$refs.similarSelect.$refs.search.focus();
                        });
                    });
            } else if (add.length > 0) {
                this.similaresAgregados.disableSimilar = true;

                /* Adicionar no back */
                this.service
                    .addSimilar(add[0])
                    .then((r) => {
                        // this.similaresAgregados.similares = newv;
                        this.loadTabSimilaresAgregados(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao adicionar produto similar', e);

                        this.msgs.push(new Message('error', 'msg-erro-add-similar', true));
                    })
                    .finally(() => {
                        this.similaresAgregados.disableSimilar = false;
                    });
            }
        },
        updateAgregados(newv) {
            let oldv = this.similaresAgregados.agregados;

            /* Entradas removidas: filtra os antigos que não estão nos novos */
            let del = oldv.filter((p) => !newv.includes(p));

            /* Entradas adicionadas: filtra os novos que não estão nos antigos */
            let add = newv
                .filter((p) => !oldv.includes(p))
                .map((p) => {
                    p.idprodutoprincipal = this.produto.idproduto;
                    return p;
                });

            if (del.length > 0) {
                this.similaresAgregados.disableAgregado = true;

                /* Remover no back */
                this.service
                    .delAgregado(del[0].id)
                    .then((r) => {
                        // this.similaresAgregados.agregados = newv;
                        this.loadTabSimilaresAgregados(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao remover produto agregado', e);

                        this.msgs.push(new Message('error', 'msg-erro-del-agregado', true));
                    })
                    .finally(() => {
                        this.similaresAgregados.disableAgregado = false;

                        this.$nextTick(() => {
                            this.$refs.agregadoSelect.open = true;
                            this.$refs.agregadoSelect.$refs.search.focus();
                        });
                    });
            } else if (add.length > 0) {
                this.similaresAgregados.disableAgregado = true;

                /* Adicionar no back */
                this.service
                    .addAgregado(add[0])
                    .then((r) => {
                        // this.similaresAgregados.agregados = newv;
                        this.loadTabSimilaresAgregados(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao adicionar produto agregado', e);

                        this.msgs.push(new Message('error', 'msg-erro-add-agregado', true));
                    })
                    .finally(() => {
                        this.similaresAgregados.disableAgregado = false;
                    });
            }
        },
        addSelectListeners() {
            setTimeout(() => {
                let simEl = document.querySelector('.form-sim-agr .similar .vs__selected-options');
                let agrEl = document.querySelector('.form-sim-agr .agregado .vs__selected-options');

                simEl.addEventListener('click', (e) => {
                    if (e.target.className != 'vs__selected-options') {
                        return;
                    }

                    if (!this.$refs.similarSelect.disabled) {
                        this.$refs.similarSelect.open = !this.$refs.similarSelect.open;

                        if (this.$refs.similarSelect.open) {
                            this.$refs.similarSelect.$refs.search.focus();
                        } else {
                            this.$refs.similarSelect.$refs.search.blur();
                        }
                    }

                    /* Prevenir que o backspace volte a página no firefox */
                    this.$refs.similarSelect.$refs.search.addEventListener('keydown', (e) => {
                        if (e.which === 8) {
                            e.preventDefault();
                        }
                    });
                });

                agrEl.addEventListener('click', (e) => {
                    if (e.target.className != 'vs__selected-options') {
                        return;
                    }

                    if (!this.$refs.agregadoSelect.disabled) {
                        this.$refs.agregadoSelect.open = !this.$refs.agregadoSelect.open;
                        this.$refs.agregadoSelect.$refs.search.focus();

                        if (this.$refs.agregadoSelect.open) {
                            this.$refs.agregadoSelect.$refs.search.focus();
                        } else {
                            this.$refs.agregadoSelect.$refs.search.blur();
                        }
                    }

                    /* Prevenir que o backspace volte a página no firefox */
                    this.$refs.agregadoSelect.$refs.search.addEventListener('keydown', (e) => {
                        if (e.which === 8) {
                            e.preventDefault();
                        }
                    });
                });
            }, 16);
        },
        loadSimilaresDisp(q) {
            this.service
                .loadSimilaresDisponiveis(this.produto.idproduto, 0, this.limit, q)
                .then((r) => {
                    if (r.content) {
                        this.similaresAgregados.similaresDisp = r.content.disponiveis;
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar pesquisa de produtos similares disponíveis. Termo de pesquisa: [${q}]`,
                        e
                    );
                });
        },
        loadAgregadosDisp(q) {
            this.service
                .loadAgregadosDisponiveis(this.produto.idproduto, 0, this.limit, q)
                .then((r) => {
                    if (r.content) {
                        this.similaresAgregados.agregadosDisp = r.content.disponiveis;
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar pesquisa de produtos agregados disponíveis. Termo de pesquisa: [${q}]`,
                        e
                    );
                });
        },
        /* MÉTODOS ABA CONFIG */
        editDesconto(row) {
            this.config.descqtd_selected = row;
            this.config.descqtd_edit.idprodutoqtdepreco = row.idprodutoqtdepreco;
            this.config.descqtd_edit.qtdeinicio = row.qtdeinicio;
            this.config.descqtd_edit.qtdefim = row.qtdefim;
            this.config.descqtd_edit.diferenca = row.diferenca;
            this.config.descqtd_edit.empresa =
                row.empresa != undefined ? row.empresa : this.config.empresas[0];
            this.config.descqtd_edit.tabpreco = row.tabpreco;
        },
        cancelDesconto() {
            this.config.descqtd_selected = null;
            this.config.descqtd_edit.idprodutoqtdepreco = null;
            this.config.descqtd_edit.qtdeinicio = '';
            this.config.descqtd_edit.qtdefim = '';
            this.config.descqtd_edit.diferenca = '';
            this.config.descqtd_edit.empresa = null;
            this.config.descqtd_edit.tabpreco = null;
        },
        loadDesconto() {
            this.config.disableInputsDesconto = true;

            this.service
                .loadDescontos(this.$route.params.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro ${r.status} ao carregar a tabela de desconto por quantidade.`
                        );
                        this.config.descqtd_data = [];
                    } else {
                        this.config.descqtd_data = r.content;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar a tabela de desconto por quantidade.', e);
                    this.config.descqtd_data = [];
                })
                .finally(() => {
                    this.config.disableInputsDesconto = false;
                });
        },
        salvarDesconto() {
            let saving = this.config.descqtd_selected != null;

            if (this.validation.validateNovoDesconto(this.config.descqtd_edit)) {
                this.config.disableInputsDesconto = true;
                let desconto = {};

                if (this.config.descqtd_selected != null) {
                    desconto.idprodutoqtdepreco = this.config.descqtd_selected.idprodutoqtdepreco;
                }

                desconto.idproduto = this.$route.params.id;
                desconto.idtabpreco = this.config.descqtd_edit.tabpreco.id;
                desconto.qtdeinicio = this.config.descqtd_edit.qtdeinicio;
                desconto.qtdefim = this.config.descqtd_edit.qtdefim;
                desconto.diferenca = this.config.descqtd_edit.diferenca;

                let emp = {
                    idempresa: this.config.descqtd_edit.empresa.id,
                    nome: this.config.descqtd_edit.empresa.nome,
                };

                desconto.empresa = emp;

                this.service
                    .saveDesconto(desconto)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao salvar desconto por quantidade.`);
                            if (saving) {
                                this.showMessage('error', 'msg-erro-add-desc-qtd-save');
                            } else {
                                this.showMessage('error', 'msg-erro-add-desc-qtd');
                            }
                        } else {
                            if (saving) {
                                this.showMessage('success', 'msg-success-add-desc-qtd-save');
                            } else {
                                this.showMessage('success', 'msg-success-add-desc-qtd');
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar desconto', e);
                        if (saving) {
                            this.showMessage('error', 'msg-erro-add-desc-qtd-save');
                        } else {
                            this.showMessage('error', 'msg-erro-add-desc-qtd');
                        }
                    })
                    .finally(() => {
                        this.cancelDesconto();
                        this.config.disableInputsDesconto = false;
                        this.loadDesconto();
                    });
            }
        },
        excluirDesconto(desc) {
            /* Realizar exclusão do item no backend */
            this.service
                .delDesconto(desc.idprodutoqtdepreco)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao remover desconto por quantidade.`);
                        this.showMessage('error', 'msg-erro-del-desc-qtd');
                    } else {
                        this.showMessage('success', 'msg-success-del-desc-qtd');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao remover desconto por quantidade', e);
                    this.showMessage('error', 'msg-erro-del-desc-qtd');
                })
                .finally(() => {
                    // Reabilitar a entrada
                    this.config.disableInputsDesconto = false;
                    this.loadDesconto();
                });
        },
        editMultiplicador(row) {
            if (
                (row.multiplicador != 0 && row.multiplicador != 1) ||
                (row.multiplicadortroca != 0 && row.multiplicadortroca != 1)
            ) {
                this.bloqueiaMultiplicadorERP = true;
            } else {
                this.bloqueiaMultiplicadorERP = false;
                this.config.mult_selected = row;
                this.config.mult_edit.venda = row.multiplicadorweb;
                this.config.mult_edit.troca = row.multiplicadortrocaweb;
                this.config.mult_edit.empresa = row.empresa;
            }
        },
        cancelMultiplicador() {
            this.bloqueiaMultiplicadorERP = false;
            this.config.mult_selected = null;
            this.config.mult_edit.venda = '';
            this.config.mult_edit.troca = '';
            this.config.mult_edit.empresa = null;
        },
        loadMultiplicador() {
            this.config.disableInputsMultiplicador = true;

            this.service
                .loadMultiplicadores(this.$route.params.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro ${r.status} ao carregar a tabela de associação de produto com empresa.`
                        );
                        this.config.mult_data = [];
                    } else {
                        this.config.mult_data = r.content;
                    }
                })
                .catch((e) => {
                    console.error(
                        'Erro ao carregar a tabela de associação de produto com empresa.',
                        e
                    );
                    this.config.mult_data = [];
                })
                .finally(() => {
                    this.config.disableInputsMultiplicador = false;
                });
        },
        salvarMultiplicador() {
            if (this.validation.validateNovoMultiplicador(this.config.mult_edit)) {
                let mult = {};

                this.config.disableInputsMultiplicador = true;

                if (this.config.mult_selected != null) {
                    mult = this.config.mult_selected;
                } else {
                    mult.idassprodutoempresa = null;
                }

                mult.multiplicadorweb = this.config.mult_edit.venda;
                mult.multiplicadortrocaweb = this.config.mult_edit.troca;
                mult.idempresa = this.config.mult_edit.empresa.id;

                this.service
                    .saveMultiplicador(mult)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao salvar desconto por quantidade.`);
                            this.showMessage('error', 'msg-erro-add-mult-save');
                        } else {
                            this.showMessage('success', 'msg-success-add-mult-save');
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar multiplicador', e);
                        this.showMessage('error', 'msg-erro-add-mult-save');
                    })
                    .finally(() => {
                        this.cancelMultiplicador();
                        this.config.disableInputsMultiplicador = false;
                        this.loadMultiplicador();
                    });
            }
        },
        excluirMultiplicador(mult) {
            this.service
                .delMultiplicador(mult.idassprodutoempresa)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao salvar desconto por quantidade.`);
                        this.showMessage('error', 'msg-erro-del-mult');
                    } else {
                        this.showMessage('success', 'msg-success-del-mult');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar desconto por quantidade', e);
                    this.showMessage('error', 'msg-erro-del-mult');
                })
                .finally(() => {
                    // Reabilitar a entrada
                    this.config.disableInputsMultiplicador = false;
                    this.loadMultiplicador();
                });
        },
        salvarConfig() {
            /* Criar objeto de config para enviar para o back */
            let cfg = { ...this.produto };

            cfg.oculta = this.config.oculta.id;
            cfg.porctroca = this.config.porctroca;

            if (this.validation.validateNovaConfig(cfg)) {
                this.config.disableInputsConfig = true;

                /* Salvar no backend */
                this.service
                    .saveConfig(cfg)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao salvar configurações diversas.`);

                            this.loadingTab = false;
                            this.showMessage('error', 'msg-erro-config-div');
                            this.revertStartValuesConfig();
                        } else {
                            this.showMessage('success', 'msg-success-config-div');
                            this.saveStartValuesConfig();
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar configurações diversas', e);

                        this.loadingTab = false;
                        this.showMessage('error', 'msg-erro-config-div');
                        this.revertStartValuesConfig();
                    })
                    .finally(() => {
                        // Reabilitar a entrada
                        this.config.disableInputsConfig = false;
                    });
            }
        },
        revertStartValuesConfig() {
            this.config.oculta = this.config.ocultacatoptions[this.config.startValues.oculta];
            this.config.porctroca = this.config.startValues.porctroca;
        },
        saveStartValuesConfig() {
            this.config.startValues.oculta = this.config.oculta.id;
            this.config.startValues.porctroca = this.config.porctroca;
        },
        loadVendedores(q) {
            this.config.empresasLoading = true;

            this.empresaService
                .findAllOld(0, 20, q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por empresa. Termo: [${q}].`
                        );
                        this.config.empresas = [];
                    } else {
                        this.config.empresas = r.content.map((v) => {
                            return {
                                id: v.id,
                                nome: v.nome.toLocaleUpperCase(),
                            };
                        });
                        this.config.empresas.unshift({
                            id: 0,
                            nome: 'todas',
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por empresa. Termo: [${q}].`, e);
                    this.config.empresas = [];
                })
                .finally(() => {
                    this.config.empresasLoading = false;
                });
        },
        loadTabelasPreco(q) {
            this.config.tabelasPrecoLoading = true;

            this.service
                .loadTabelasPreco(0, 20, q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por tabela de preço. Termo: [${q}].`
                        );
                        this.config.tabelasPreco = [];
                    } else {
                        this.config.tabelasPreco = r.content.map((v) => {
                            return {
                                id: v.id,
                                descricao: v.descricao.toLocaleUpperCase(),
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa por tabela de preço. Termo: [${q}].`,
                        e
                    );
                    this.config.tabelasPreco = [];
                })
                .finally(() => {
                    this.config.tabelasPrecoLoading = false;
                });
        },
        /* MÉTODOS ABA CULTURAS */
        updateCulturas(newv) {
            let oldv = this.cultura.culturas;

            // let toSave = [...oldv]

            let del = oldv.filter((p) => !newv.includes(p));
            // del.forEach(d => {
            //     d.datahoradel = new Date();
            //     toSave.push(d);
            // })

            let add = newv.filter((p) => !oldv.includes(p));
            add.forEach((a) => {
                a.idproduto = this.produto.idproduto;
                // toSave.push(a);
            });

            if (add.length) {
                this.cultura.disableCultura = true;
                this.service
                    .addCulturasAoProduto(add[0])
                    .then((r) => {
                        this.loadTabCultura(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao remover cultura do produto', e);

                        this.msgs.push(new Message('error', 'msg-erro-del-cultura', true));
                    })
                    .finally(() => {
                        this.cultura.disableCultura = false;
                    });
            }

            if (del.length) {
                this.cultura.disableCultura = true;
                this.service
                    .removerCulturasDoProduto(del[0].idasstipoculturaproduto)
                    .then((r) => {
                        this.loadTabCultura(true);
                    })
                    .catch((e) => {
                        this.loadTab(this.abaAtual);
                        console.error('Erro ao remover cultura do produto', e);

                        this.msgs.push(new Message('error', 'msg-erro-del-cultura', true));
                    })
                    .finally(() => {
                        this.cultura.disableCultura = false;

                        this.$nextTick(() => {
                            this.$refs.culturaSelect.open = true;
                            this.$refs.culturaSelect.$refs.search.focus();
                        });
                    });
            }
        },
        addCulturaSelectListeners() {
            setTimeout(() => {
                let el = document.querySelector('.form-cultura .cultura .vs__selected-options');

                el.addEventListener('click', (e) => {
                    if (e.target.className != 'vs__selected-options') {
                        return;
                    }

                    this.$refs.culturaSelect.open = !this.$refs.culturaSelect.open;

                    if (this.$refs.culturaSelect.open) {
                        this.$refs.culturaSelect.$refs.search.focus();
                    } else {
                        this.$refs.culturaSelect.$refs.search.blur();
                    }

                    /* Prevenir que o backspace volte a página no firefox */
                    this.$refs.culturaSelect.$refs.search.addEventListener('keydown', (e) => {
                        if (e.which === 8) {
                            e.preventDefault();
                        }
                    });
                });
            }, 33);
        },
        loadCulturasDisponiveis(q) {
            this.service
                .loadCulturasDisponiveis(this.produto.idproduto, 0, this.limit, q)
                .then((r) => {
                    this.cultura.culturasDisponiveis = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar pesquisa de culturas disponíveis. Termo de pesquisa: [${q}]`,
                        e
                    );
                });
        },
        /* MÉTODOS ABA LICENÇA */
        loadLicencaDisp(q) {
            this.licenca.isLoading = true;

            let func = this.service.loadLicencasDisp(this.produto.idproduto, 0, this.limit);
            if (q) {
                func = this.service.loadLicencasDisp(this.produto.idproduto, 0, this.limit, q);
            }

            func.then((r) => {
                this.licenca.disponiveis = r.content;
            })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar pesquisa de licenças disponíveis. Termo de pesquisa: [${q}]`,
                        e
                    );
                })
                .finally(() => {
                    this.licenca.isLoading = false;
                });
        },
        excluirLicenca(item) {
            this.loadingTab = true;

            this.service
                .delLicenca(item)
                .then((r) => {
                    this.msgs.push(new Message('success', 'msg-success-del-licenca', true));

                    // Recarrega a aba
                    this.loadTab(this.abaAtual);
                })
                .catch((e) => {
                    console.error('Erro ao excluir licença', e);

                    this.msgs.push(new Message('error', 'msg-erro-del-licenca', true));

                    this.loadingTab = false;
                });
        },
        addLicenca() {
            if (this.licenca.selected != null) {
                this.licenca.isSaving = true;

                this.licenca.selected.idproduto = this.produto.idproduto
                    ? this.produto.idproduto
                    : this.$route.params.id;

                this.service
                    .addLicenca(this.licenca.selected)
                    .then((r) => {
                        this.licenca.selected = null;
                        this.msgs.push(new Message('success', 'msg-success-add-licenca', true));

                        // Recarrega a aba
                        this.loadTab(this.abaAtual);
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar licença', e);

                        this.msgs.push(new Message('error', 'msg-erro-add-licenca', true));
                    })
                    .finally(() => {
                        this.licenca.isSaving = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$padding: 5px;

@mixin smallbtn() {
    height: 36px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}

#main {
    padding: 0 15px 0 21px;
    height: auto;
}

input {
    color: $darker-gray-color;
}

button {
    &.btn-add-small {
        @include smallbtn();
    }

    &.btn-del-small {
        @include smallbtn();
        @include exclude-button();
        color: $darker-gray-color;
    }
}

.page {
    position: relative;

    .novo-produto {
        color: $darker-gray-color;
        position: relative;
        width: 100%;
        //min-height: calc(100vh - 50px);
        display: flex;
        flex-flow: column;
        padding-top: 0;

        > h1.title {
            padding-top: 20px;
            margin-bottom: 0px;
            margin-right: 0;
        }

        .tab-subtitle {
            text-transform: uppercase;
        }

        .form-geral {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 15px;

            .peso,
            .unmedida,
            .embalagem,
            .uncaixa {
                width: calc((100% / 4) - #{$padding});
            }

            .codigo,
            .grupo,
            .subgrupo,
            .linha,
            .codbarras,
            .ncm,
            .marca {
                width: calc((100% / 3) - #{$padding});
            }

            .descricao {
                width: calc(67% - #{$padding});
            }
        }

        .nav.nav-tabs {
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-left: 0px;
            font-size: 12px;

            &::after {
                content: '';
                flex: auto;
            }

            & li {
                margin-right: 0;
                margin-left: 20px;

                &.active > a {
                    color: $primary-color-click;
                }
            }
        }

        .v-input,
        .v-select,
        input {
            height: 36px;
        }
        .full-height,
        .full-height .vs__search {
            height: auto !important;
            padding-bottom: 10px;
        }
        .v-select input {
            height: 24px;
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }

        .empty {
            fill: #898989;
            width: 50px !important;
            height: 50px !important;
        }

        .form-loader {
            display: flex;
            height: 200px;
            align-items: center;
            align-content: center;
            flex-wrap: wrap;
            flex-grow: 1;
            justify-content: center;

            div {
                width: 100%;
                display: flex;
                justify-content: center;
            }

            .loading-tab-text {
                font-weight: 600;
                margin-top: 10px;
            }

            svg.loading {
                fill: #898989;
                width: 50px !important;
                height: 50px !important;
                animation-name: spin;
                animation-duration: 2000ms;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
            }
        }

        .data-table .table-empty {
            border: 1px solid $table-border;
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;
            flex-wrap: wrap;
            font-weight: 600;
            height: 100px;

            div {
                display: flex;
                justify-content: center;
                width: 100%;
            }
        }

        .form-un-medida,
        .form-licenca,
        .form-config,
        .form-fornecedores,
        .form-estoque {
            height: 100%;
        }
        .form-lote {
            .data-table {
                .td-cell div {
                    display: flex;
                    align-items: center;
                    min-height: 30px;
                }
            }
        }

        .form-tab-preco {
            .tabpreco-detail-field td {
                border: none;
            }
        }

        .form-un-medida {
            .um-add {
                display: flex;
                width: 100%;

                .select-add {
                    width: 100%;
                }

                .add-button,
                .perc-input,
                .fator-input {
                    margin-left: 5px;

                    button {
                        margin-left: 0px;
                    }
                }

                .add-button {
                    display: flex;
                    align-items: flex-end;
                }
            }
        }

        .form-estoque,
        .form-config {
            margin-bottom: 20px;

            .data-table {
                margin-top: 5px;
            }

            .lote {
                margin-top: 15px;
            }
        }

        .form-sim-agr {
            .agregado {
                margin-top: 10px;
            }
        }

        .form-cultura {
            .cultura {
                margin-top: 10px;
            }
        }

        .form-observacoes {
            .campo-observacao {
                margin-top: 10px;
            }
        }

        .form-config {
            .desc-qtd-edit,
            .conf-diversos,
            .mult-edit {
                display: flex;
                margin-top: 10px;

                .oculta-input,
                .porctroca-input {
                    width: 100%;

                    &:not(:first-child) {
                        margin-left: 5px;
                    }
                }

                .venda-input,
                .troca-input {
                    width: calc(50% - #{$padding}/ 2);
                }

                .ini-input,
                .fim-input,
                .reajuste-input,
                .empresa-desc-input {
                    width: calc((100% / 4) - #{$padding}/ 2);
                }

                .empresa-input,
                .tabpreco-input {
                    width: calc(100% - 150px - #{$padding});
                }

                .add-button {
                    display: flex;
                    align-items: flex-end;
                    margin-left: 5px;

                    button {
                        margin-left: 0px;
                    }

                    button:not(:first-child) {
                        margin-left: 5px;
                    }
                }
            }

            .mult-edit,
            .desc-qtd-edit {
                flex-wrap: wrap;
                justify-content: space-between;

                .add-button {
                    width: 150px;

                    button {
                        display: flex;
                        flex-grow: 1;
                    }
                }
            }

            .config-empty,
            .data-table {
                min-height: 150px;
            }
        }

        .form-licenca {
            .add-licenca {
                display: flex;
                width: 100%;

                .select-add {
                    width: 100%;
                }

                .btn-add {
                    display: flex;
                    align-items: flex-end;
                    margin-left: 5px;

                    button {
                        margin-left: 0px;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .page .novo-produto {
        .form-geral {
            .peso,
            .unmedida,
            .embalagem,
            .uncaixa,
            .codigo,
            .grupo,
            .subgrupo,
            .linha,
            .codbarras,
            .ncm,
            .marca,
            .descricao {
                width: 100%;
            }
        }

        .form-un-medida .um-add {
            flex-wrap: wrap;
            width: 100%;

            .perc-input,
            .fator-input {
                width: 40%;
            }

            .add-button {
                width: calc(20% - 10px);

                button {
                    width: 100%;
                }
            }

            .perc-input {
                margin-left: 0;
            }
        }

        .form-config {
            .desc-qtd-edit,
            .conf-diversos,
            .mult-edit {
                flex-wrap: wrap;

                .ini-input,
                .fim-input,
                .reajuste-input,
                .empresa-desc-input,
                .oculta-input,
                .porctroca-input,
                .codref-input,
                .venda-input,
                .troca-input,
                .empresa-input,
                .tabpreco-input {
                    margin-top: 5px;
                    margin-left: 0px !important;
                    width: 100%;
                }

                .add-button {
                    margin-top: 20px;
                    margin-left: 0;
                    width: 100%;
                    flex-direction: row-reverse;

                    button {
                        width: 100%;

                        &:not(:first-child) {
                            margin-left: 0;
                        }
                    }

                    button ~ button {
                        margin-right: $padding;
                    }
                }
            }
        }
    }

    .nav.nav-tabs {
        display: none;
    }
}

@media only screen and (max-width: 500px) {
    .page .novo-produto {
        .form-un-medida .um-add {
            .perc-input,
            .fator-input {
                margin-top: 5px;
                margin-left: 0;
                width: 100%;
            }

            .add-button {
                margin-top: 20px;
                margin-left: 0;
                width: 100%;
            }
        }
    }
}

@media only screen and (min-width: 760px) and (max-width: 960px) {
    .page .novo-produto .form-geral {
        .peso,
        .unmedida,
        .embalagem,
        .uncaixa {
            width: calc((100% / 2) - #{$padding});
        }
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
